import { css } from '@emotion/react';

import { classes as inputClasses } from '@core/forms/Input/getInputCss';
import { classes as selectClasses } from '@core/forms/Select/getSelectCss';
import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('silentSelect', [
  'label',
  'stackedLabel',
  'container',
  'input',
  'filled',
]);

const getSilentSelectFieldCss = css`
  max-width: 400px;
  display: inline-flex;
  flex-direction: column;

  .${classes.filled} {
    color: var(--cds-color-neutral-primary);
  }

  .${classes.stackedLabel} {
    margin-bottom: var(--cds-spacing-100);
  }

  .${classes.input} {
    background: transparent;

    .${selectClasses.select} {
      padding-left: 0;
      padding-right: var(--cds-spacing-300);
    }

    .${selectClasses.icon} {
      left: auto;
      right: 0;
    }

    .${inputClasses.notchedOutline} {
      border-width: 0;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    &:hover {
      background: transparent;

      .${inputClasses.notchedOutline} {
        border-bottom-width: 2px;
        border-color: var(--cds-color-neutral-stroke-primary-weak);
      }
    }

    &.${selectClasses.opened} {
      .${inputClasses.notchedOutline} {
        border-bottom-width: 2px;
        border-color: var(--cds-color-interactive-secondary);
      }
    }

    &.${inputClasses.focused} {
      &.${selectClasses.focusVisible} {
        .${inputClasses.notchedOutline} {
          border-width: 0;
          border-bottom-width: 2px;
          border-color: var(--cds-color-neutral-stroke-primary-weak);
        }
      }
    }
  }
`;

export default getSilentSelectFieldCss;
